import { graphql } from "react-relay";

export const AddTemplateMutation = graphql`
  mutation AddTemplateMutation($input: TemplateInput!, $connections: [ID!]!) {
    addTemplate(input: $input) {
      template
        @appendNode(connections: $connections, edgeTypeName: "TemplateEdge") {
        content
        name
        transport
      }
    }
  }
`;
